import React from 'react'
import { ButtonPrimary, FormControl } from 'front-end/src/components'
import Label from 'front-end/src/components/common/form/label/Label'
import { QUESTIONS_OPTIONS } from 'front-end/src/pages/auth/security-questions/SecurityQuestionsOptions'
import { Trans } from '@lingui/macro'
import { useFormikContext } from 'formik'
import { ResetPasswordViaSecurityQuestionsFormValues } from 'front-end/src/pages/auth/reset-password/ResetPasswordViaSecurityQuestionsFormik'
import { InputControl } from 'formik-chakra-ui'
import IconArrowRight from 'front-end/src/components/common/icon/IconArrowRight'

export const ResetPasswordViaSecurityQuestionsForm = () => {
  const { handleSubmit, values, isValid } =
    useFormikContext<ResetPasswordViaSecurityQuestionsFormValues>()

  return (
    <form onSubmit={handleSubmit}>
      {values.map((value, index) => (
        <FormControl mt="24px" key={value.question}>
          <Label>
            {QUESTIONS_OPTIONS.find((q) => q.value === value.question)?.label}
          </Label>
          <InputControl mt="16px" name={`[${index}]answer`} />
        </FormControl>
      ))}

      <ButtonPrimary
        disabled={!isValid}
        type="submit"
        isFullWidth
        mt="32px"
        rightIcon={<IconArrowRight />}
      >
        <Trans>Next</Trans>
      </ButtonPrimary>
    </form>
  )
}
